import Component from '../inherited/Component'

export default class MethodCall extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount () {
    if (this._options.length) {
      for (let option of this._options) {
        this._optionLogic(option)
      }
    } else {
      this._optionLogic(this._options)
    }
  }

  _optionLogic(option) {

    if (option.on === 'keydown') {
      document.addEventListener(option.on, e => {
        if (e.keyCode === option.keyCode) this._eventLogic(option, e)
      }, option.preventDefault ? { passive: false } : { passive: true })
    } else {
      this._elem.addEventListener(option.on, e => {
        this._eventLogic(option, e)
      }, option.preventDefault ? { passive: false } : { passive: true })
    }
    
  }

  _eventLogic (option, e) {
    if (option.preventDefault) {
      e.preventDefault()
    }

    if (option.onlyThisElem && e.target !== this._elem) {
      return false
    }
    
    let comp = this._theme.getComponent(option.componentId).component
    comp[option.method](...option.args)
  }
}